import React, { useRef, useState } from 'react'
import { TextField, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import apiUrl from '@common/utils/apiURL';
import axiosInstance from '@common/utils/axiosInstance';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
};

const stateOptions = [
    { value: 'andhra_pradesh', label: 'Andhra Pradesh' },
    { value: 'arunachal_pradesh', label: 'Arunachal Pradesh' },
    { value: 'assam', label: 'Assam' },
    { value: 'bihar', label: 'Bihar' },
    { value: 'chhattisgarh', label: 'Chhattisgarh' },
    { value: 'goa', label: 'Goa' },
    { value: 'gujarat', label: 'Gujarat' },
    { value: 'haryana', label: 'Haryana' },
    { value: 'himachal_pradesh', label: 'Himachal Pradesh' },
    { value: 'jharkhand', label: 'Jharkhand' },
    { value: 'karnataka', label: 'Karnataka' },
    { value: 'kerala', label: 'Kerala' },
    { value: 'madhya_pradesh', label: 'Madhya Pradesh' },
    { value: 'maharashtra', label: 'Maharashtra' },
    { value: 'manipur', label: 'Manipur' },
    { value: 'meghalaya', label: 'Meghalaya' },
    { value: 'mizoram', label: 'Mizoram' },
    { value: 'nagaland', label: 'Nagaland' },
    { value: 'odisha', label: 'Odisha' },
    { value: 'punjab', label: 'Punjab' },
    { value: 'rajasthan', label: 'Rajasthan' },
    { value: 'sikkim', label: 'Sikkim' },
    { value: 'tamil_nadu', label: 'Tamil Nadu' },
    { value: 'telangana', label: 'Telangana' },
    { value: 'tripura', label: 'Tripura' },
    { value: 'uttar_pradesh', label: 'Uttar Pradesh' },
    { value: 'uttarakhand', label: 'Uttarakhand' },
    { value: 'west_bengal', label: 'West Bengal' },
    { value: 'andaman_nicobar', label: 'Andaman and Nicobar Islands' },
    { value: 'chandigarh', label: 'Chandigarh' },
    { value: 'dadra_nagar_haveli_daman_diu', label: 'Dadra and Nagar Haveli and Daman and Diu' },
    { value: 'delhi', label: 'Delhi' },
    { value: 'lakshadweep', label: 'Lakshadweep' },
    { value: 'puducherry', label: 'Puducherry' },
    { value: 'jammu_kashmir', label: 'Jammu and Kashmir' },
    { value: 'ladakh', label: 'Ladakh' }
];

function Form() {
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const recaptchaRef = useRef(null);
    const formik = useFormik({
        initialValues: {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            city: '',
            state: '',
            address: '',
            terms: false,
            recaptcha: '',
        },
        validationSchema: Yup.object({
            firstName: Yup.string().required('Required'),
            lastName: Yup.string().required('Required'),
            email: Yup.string().email('Invalid email address').required('Required'),
            phone: Yup.string().matches(/^[0-9]{10}$/, 'Must be a valid phone number').required('Required'),
            city: Yup.string().required('Required'),
            state: Yup.string().required('Required'),
            address: Yup.string().required('Required'),
            terms: Yup.boolean().oneOf([true], 'You must accept the terms and conditions').required('Required'),
            recaptcha: Yup.string().required('reCAPTCHA is required'),
        }),
        onSubmit: async (values, { setSubmitting }) => {
            const payload = {
                first_name: values.firstName,
                last_name: values.lastName,
                email: values.email,
                phone: values.phone,
                city: values.city,
                state: values.state,
                address: values.address,
            };

            const contactUsURL = apiUrl.franchiseEnquiry;
            await axiosInstance.post(contactUsURL, payload)
                .then((response) => {
                    if (response.status === 200) {
                        formik.resetForm();
                        setOpenConfirmationModal(true);
                        recaptchaRef.current.reset();

                        setTimeout(() => {
                            setOpenConfirmationModal(false);
                        }, 1500);
                    }
                })
                .catch((error) => {
                    console.log('franchise enquiry form request failed', error);
                });
        },
    });

    const handleCloseConfirmationModal = () => {
        setOpenConfirmationModal(false);
    };

    return (
        <>
            <div className='bs-section'>
                <div className='bs-section__section-head'>
                    <h2 className='bs-section__title'>REQUEST A FRANCHISE ENQUIRY</h2>
                </div>
                <div className='bs-section__section-cont'>
                    <p className='bs-section__desc'>Our team will connect with you as soon as possible!</p>
                    <form onSubmit={formik.handleSubmit}>
                        <div className='bs-form'>
                            <div className={`bs-form__form-group ${formik.touched.firstName && formik.errors.firstName ? 'bs-form__error' : ''}`}>
                                <TextField
                                    id="firstName"
                                    name="firstName"
                                    type="text"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.firstName}
                                    label="First Name"
                                    className='bs-form__form-control'
                                />
                                {formik.touched.firstName && formik.errors.firstName ? (
                                    <div className='bs-form__error-text'>{formik.errors.firstName}</div>
                                ) : null}
                            </div>
                            <div className={`bs-form__form-group ${formik.touched.lastName && formik.errors.lastName ? 'bs-form__error' : ''}`}>
                                <TextField
                                    id="lastName"
                                    name="lastName"
                                    type="text"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.lastName}
                                    label="Last Name"
                                    className='bs-form__form-control'
                                />
                                {formik.touched.lastName && formik.errors.lastName ? (
                                    <div className='bs-form__error-text'>{formik.errors.lastName}</div>
                                ) : null}
                            </div>
                            <div className={`bs-form__form-group ${formik.touched.email && formik.errors.email ? 'bs-form__error' : ''}`}>
                                <TextField
                                    id="email"
                                    name="email"
                                    type="email"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.email}
                                    label="E-mail"
                                    className='bs-form__form-control'
                                />
                                {formik.touched.email && formik.errors.email ? (
                                    <div className='bs-form__error-text'>{formik.errors.email}</div>
                                ) : null}
                            </div>
                            <div className={`bs-form__form-group ${formik.touched.phone && formik.errors.phone ? 'bs-form__error' : ''}`}>
                                <TextField
                                    id="phone"
                                    name="phone"
                                    type="text"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.phone}
                                    label="Phone"
                                    className='bs-form__form-control'
                                />
                                {formik.touched.phone && formik.errors.phone ? (
                                    <div className='bs-form__error-text'>{formik.errors.phone}</div>
                                ) : null}
                            </div>
                            <div className={`bs-form__form-group ${formik.touched.city && formik.errors.city ? 'bs-form__error' : ''}`}>
                                <TextField
                                    id="city"
                                    name="city"
                                    type="text"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.city}
                                    label="City"
                                    className='bs-form__form-control'
                                />
                                {formik.touched.city && formik.errors.city ? (
                                    <div className='bs-form__error-text'>{formik.errors.city}</div>
                                ) : null}
                            </div>
                            <div className={`bs-form__form-group ${formik.touched.state && formik.errors.state ? 'bs-form__error' : ''}`}>
                                <FormControl fullWidth>
                                    <InputLabel id="state-label">State</InputLabel>
                                    <Select
                                        labelId="state-label"
                                        id="state"
                                        name="state"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.state}
                                        label="State"
                                        className='bs-form__form-control'
                                        IconComponent={(props) => (
                                            <span
                                                {...props}
                                                className={`icon icon-angle-down ${props.className}`}
                                            ></span>
                                        )}
                                        MenuProps={{
                                            classes: {
                                                paper: "bs-menu-dropdown",
                                            },
                                        }}
                                    >
                                        {stateOptions.map((item, index) => {
                                            return <MenuItem value={item.value} key={index}>{item.label}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                                {formik.touched.state && formik.errors.state ? (
                                    <div className='bs-form__error-text'>{formik.errors.state}</div>
                                ) : null}
                            </div>
                            <div className={`bs-form__form-group bs-form__form-group--full-width ${formik.touched.address && formik.errors.address ? 'bs-form__error' : ''}`}>
                                <TextField
                                    id="address"
                                    name="address"
                                    type="text"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.address}
                                    label="Address"
                                    className='bs-form__form-control'
                                />
                                {formik.touched.address && formik.errors.address ? (
                                    <div className='bs-form__error-text'>{formik.errors.address}</div>
                                ) : null}
                            </div>
                            <div className={`bs-form__form-bottom-wrap ${formik.touched.terms && formik.errors.terms ? 'bs-form__error' : ''}`}>
                                <div className='bs-checkbox'>
                                    <input
                                        type="checkbox"
                                        id="terms"
                                        name="terms"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        checked={formik.values.terms}
                                    />
                                    <label className="bs-checkbox__label" htmlFor="terms">I agree to <Link to="/tnc" className='bs-checkbox__link'>terms & Conditions</Link></label>
                                    {formik.touched.terms && formik.errors.terms ? (
                                        <div className='bs-form__error-text'>{formik.errors.terms}</div>
                                    ) : null}
                                </div>
                                <div className={`${formik.touched.recaptcha && formik.errors.recaptcha ? 'bs-form__error' : ''}`}>
                                    <ReCAPTCHA
                                        ref={recaptchaRef}
                                        sitekey="6LcSFQsqAAAAAJPkl0Nyx8wH7UMvWVxMTK9O50yd"
                                        onChange={(value) => formik.setFieldValue('recaptcha', value)}
                                    />
                                    {formik.touched.recaptcha && formik.errors.recaptcha ? (
                                        <div className='bs-form__error-text'>{formik.errors.recaptcha}</div>
                                    ) : null}
                                </div>
                                <button className='bs-btn bs-btn__btn-solid' type='submit' disabled={formik.isSubmitting}>Send</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <Modal
                open={openConfirmationModal}
                onClose={handleCloseConfirmationModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className='bs-modal bs-modal--typ-sm'
            >
                <Box className='bs-modal__wrapper' sx={style}>
                    <div className='bs-modal__content'>
                        <div className='mod-message'>
                            <span className='icon icon-check-circle mod-message__icon'></span>
                            <p className='mod-message__title'>Thank you for your franchise enquiry</p>
                            <p className='mod-message__desc'>We will get back to you shortly</p>
                        </div>
                    </div>
                </Box>
            </Modal>
        </>
    );
}

export default Form
